import axios from '@/assets/utils/request';
import store from '@/store';
import msalInstance from '@/msal';

var utility = {
  getShopsbyMerchant: function (merchantId, isredirect, needReload) {
    //0E8F7BE0-9D62-41D4-9D82-BEB9CD47F8A7
    axios
      .get('/shop/byMerchant/' + merchantId)
      .then(function (res) {
        var shopCollection = {
          metroLines: res.metroLines,
          malls: res.malls,
          shops: res.shops
        };
        store.dispatch('setShopCollectionCache', shopCollection);
        if (isredirect)
          window.location.href = process.env.VUE_APP_AAD_B2C_REDIRECT_URI;
        else if (needReload) {
          window.location.reload();
        }
      })
      .catch((err) => {
        if (err) console.error(err);
        //alert('get shop collection failed, please check console log');
      });

    utility.getCountryCode();
  },
  getShopsbyShop: function (shopid, isredirect, needReload) {
    axios
      .get('/shop/byShop/' + shopid)
      .then(function (res) {
        var shopCollection = {
          metroLines: res.metroLines,
          malls: res.malls,
          shops: res.shops
        };
        store.dispatch('setShopCollectionCache', shopCollection);
        if (isredirect)
          window.location.href = process.env.VUE_APP_AAD_B2C_REDIRECT_URI;
        else if (needReload) {
          window.location.reload();
        }
      })
      .catch((err) => {
        if (err) console.error(err);
        //alert('get shop collection failed, please check console log');
      });
    utility.getCountryCode();
  },
  getUserInfo: function () {
    const token = store.getters.get_Signin_info;
    console.info('[Utility] getUserInfo called, token present:', !!token, 'length:', token ? token.length : 0);
    axios
      .get('/User')
      .then(function (res) {
        console.info('[Utility] getUserInfo API returned:', res ? Object.keys(res) : 'null');
        let user = res;
        store.dispatch(
          'setServerpictureBase64',
          decodeURIComponent(user.pictureBase64)
        );
        user.pictureBase64 = '';

        // user.isMerchant = true;
        // user.merchantId = '0E8F7BE0-9D62-41D4-9D82-BEB9CD47F8A7';

        store.dispatch('setuserInfocache', user);
        console.info('[Utility] userInfo saved, isMerchant:', user.isMerchant, 'shopid:', user.shopid, 'merchantId:', user.merchantId);
        if (user.isMerchant) {
          console.info('[Utility] Calling getShopsbyMerchant for merchantId:', user.merchantId);
          utility.getShopsbyMerchant(user.merchantId, true);
        } else {
          console.info('[Utility] Calling getShopsbyShop for shopid:', user.shopid);
          utility.getShopsbyShop(user.shopid, true);
        }
      })
      .catch((err) => {
        console.error('[Utility] getUserInfo error:', err);
        if (err.response) {
          console.error('[Utility] HTTP status:', err.response.status);
          console.error('[Utility] Response data:', err.response.data);
        }
        if (err.message == "Contact status is not available.") {
          setTimeout(() => {
            store.dispatch('setSignininfo', '');
            msalInstance.logoutRedirect();
          }, 2000);
        }
      });
  },
  getCountryCode: function () {
    axios
      .get('/CountryCode/list')
      .then(function (res) {
        store.dispatch('setCountryCode', res);
      })
      .catch((err) => {
        console.error(err);
      });
  }
};
export default utility;
